import { render, staticRenderFns } from "./BarcodesAssembly.vue?vue&type=template&id=c2754424&scoped=true&"
import script from "./BarcodesAssembly.vue?vue&type=script&lang=js&"
export * from "./BarcodesAssembly.vue?vue&type=script&lang=js&"
import style0 from "./BarcodesAssembly.vue?vue&type=style&index=0&id=c2754424&scoped=true&lang=css&"
import style1 from "./BarcodesAssembly.vue?vue&type=style&index=1&lang=css&"
import style2 from "./BarcodesAssembly.vue?vue&type=style&index=2&id=c2754424&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2754424",
  null
  
)

export default component.exports